import React from 'react'
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
  useGetCrossDockingDetailQuery,
  useUpdateCrossDockingMutation
} from "store/services/crossDockingApi";

import CrossDockingForm from "./CrossDockingComponents/CrossDockingForm";

const CrossDockingEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Cross Docking", path: "/app/crm/cross-docking/list" },
    { title: "Edit Cross Docking" },
  ];

  // RTK Query
  const {
    data: crossDockingDetail,
    isLoading: loadingCrossDocking,
    error,
  } = useGetCrossDockingDetailQuery(id)

  const [updateCrossDocking, { isLoading: updatingCrossDocking }
  ] = useUpdateCrossDockingMutation();

  // methods
  const handleUpdateCrossDocking = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateCrossDocking({ ..._payload },).unwrap();
      toast.success("Cross Docking successfully updated!");
      navigate(`/app/crm/cross-docking/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Cross Docking !"
      );
    }
  };

  useAppMeta("Edit Cross Docking");
  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCrossDocking || updatingCrossDocking}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CrossDockingForm
          isBusy={loadingCrossDocking || updatingCrossDocking}
          crossDockingDetail={crossDockingDetail}
          onSubmit={handleUpdateCrossDocking}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  )
}

export default CrossDockingEditScreen